import React from 'react';
/*import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';*/
import { withTranslation } from 'react-i18next';
import NewWindow from "../components/NewWindow";

class ConfirmDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: props.open };
        this.yesHandler = this.yesHandler.bind(this);
        this.noHandler = this.noHandler.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.open !== this.props.open) {
            this.setState({ open: this.props.open });
        }
        //// You don't have to do this check first, but it can help prevent an unneeded render
        //if (nextProps.open !== this.state.open) {
        //    this.setState({ open: nextProps.open  });
        //}
    }

    yesHandler() {
        let autoClose = true;
        if (this.props.onYes) {
            autoClose = this.props.onYes();
        }

        if (autoClose !== false) {
            this.setState({ open: false });
        }
    }

    noHandler() {
        this.setState({ open: false });
        if (this.props.onNo)
            this.props.onNo();
    }

    render() {
        const { title, message, hiddenMessage, yesTitle, noTitle, hideNo, t } = this.props;
        return (
            <NewWindow title={title ? title : t("Please confirm")} open={this.state.open} onClose={this.noHandler} autoSize={true}>
                {message && <p style={{ margin: "5px 25px 25px 25px", textAlign: "center", fontWeight: "500" }} data-msg={hiddenMessage}>{message}</p>}
                {this.props.children}
                <div className='dialog-footer'>
                    {!hideNo && <button className="btn btn-sm btn-secondary k-button" onClick={this.noHandler}>{noTitle ? noTitle : t("No")}</button>}
                    <button className="btn btn-sm k-button btn-primary" onClick={this.yesHandler}>{yesTitle ? yesTitle : t("Yes")} </button>
                    </div>
                </NewWindow>
        );
    }
}

export default withTranslation()(ConfirmDialog);